export function resolveNotificationHubNavigateGuardKey(deeplink: string): string {
  let path = deeplink.trim();
  if (/^https?:\/\//i.test(path)) {
    try {
      const u = new URL(path);
      path = `${u.pathname}${u.search}`;
    } catch {
      return "notification_home";
    }
  }
  if (path.startsWith("/cotizaciondemateriales")) {
    return "notification_materials_quotation";
  }
  if (path.startsWith("/obrasprivadas")) {
    return "notification_private_project";
  }
  if (path.startsWith("/bolsa-trabajo")) {
    return "notification_job_offer";
  }
  if (path.startsWith("/marketplace")) {
    return "notification_marketplace";
  }
  if (path.startsWith("/perfil/")) {
    return "notification_profile";
  }
  if (path.includes("tab=")) {
    return "notification_profile";
  }
  if (path === "/dashboard" || path.startsWith("/dashboard/")) {
    return "notification_home";
  }
  return "notification_home";
}
